import React from 'react';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { Button } from '../../../components/UI-CHAKRA/Button';
import { ReactComponent as InfoIcon } from '../../../assets/images/icons/info.svg';
import { DEFAULT_PRIMARY_COLOR } from '../usePrescription/helpers.mock';
import { Flex } from '../../../components/UI-CHAKRA/Flex';

export default function ClosePrescriptionBrowserTab() {
  return (
    <Flex
      flexDir={'column'}
      gap={'15px'}
      justifyContent={'center'}
      alignItems={'center'}
      p={'30px 50px'}
      bg={'#fff'}
      borderRadius={'20px'}
    >
      <InfoIcon fill={DEFAULT_PRIMARY_COLOR} width={'120px'} height={'120px'} style={{ marginRight: '10px' }} />
      <Text fontSize={'30px'} fontWeight={700} lineHeight={'33px'} textAlign={'center'}>
        Receita Finalizada
      </Text>
      <Text fontSize={'16px'} lineHeight={'17px'} textAlign={'center'}>
        Deseja fechar essa aba do seu navegador?
      </Text>
      <Button onClick={window.close} borderRadius={'50px'}>
        Sim, fechar aba
      </Button>
    </Flex>
  );
}
